<template>
  <div class="header-menu-content">
    <slot>
      Inget innehåll agnivet
    </slot>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenuContent',
};
</script>

<style lang="scss" scoped>

  .header-menu-content {
    transition: opacity 0.6s, height 0.4s;
    height: auto;
    z-index: 50;
    overflow: visible;
    position: absolute;
    top: 55px;
    right: 0;
  }

  .header-menu-content::v-deep {
    padding: 10px;
    background-color: var(--primary-bg-hex);
    box-shadow: 0 1px 40px 2px rgba(45, 63, 155, 0.12);

    .title {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 35px;
      padding-left: 18px;
    }

    .link {
      display: flex;
      height: 50px;
      align-items: center;
      border-radius: 7px;
      padding: 0 20px;
      transition: background 0.2s;

      &.teaser {
        opacity: 0.5;
      }

      &:hover {
        background-color: var(--primary-variant-bg-hex);
      }

      .text {
        color: var(--primary-text-alt-color-hex);
        font-size: 13px;
      }

      .icon {
        text-align: right;

        img {
          height: 14px;
        }
      }
    }
  }
</style>
